import React from "react";

import {
  HStack,
  PressableProps,
  StackProps,
} from "@whoosh/design-system/src/components/primitive";

import { UnderlinedTabItem } from "./UnderlinedTabItem";

type UnderlinedTabsProps = {
  tabs: (React.ReactElement | string)[];
  activeTabIndex: number;
  setActiveTabIndex: (value: number) => void;
  containerStyle?: StackProps;
  tabStyle?: Omit<PressableProps, "children">;
};

export const UnderlinedTabs = ({
  activeTabIndex,
  tabs,
  setActiveTabIndex,
  containerStyle,
  tabStyle,
}: UnderlinedTabsProps) => {
  return (
    <HStack
      width="auto"
      maxWidth="100%"
      height={56}
      gap={2}
      borderBottomWidth={1}
      borderBottomColor="surface-dividers"
      px={6}
      {...containerStyle}
    >
      {tabs.map((tab, index) => (
        <UnderlinedTabItem
          key={index}
          index={index}
          currentIndex={activeTabIndex}
          setIndex={() => {
            setActiveTabIndex(index);
          }}
          customComponentOrTitle={tab}
          tabStyle={tabStyle}
        />
      ))}
    </HStack>
  );
};

export default UnderlinedTabs;
